import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/login/:id',
            name: 'login',
            component: resolve => (require(["@/components/login/login"], resolve)),
            children: [{
                path: '/login',
                name:'login',
                component: resolve => (require(["@/components/login/index"], resolve))
            }, {
                path: '/register',
                name:'login',
                component: resolve => (require(["@/components/login/register"], resolve))
            }, {
                path: '/personal',
                name:'login',
                component: resolve => (require(["@/components/login/personal"], resolve))
            }, {
                path: '/registerComplete',
                name:'login',
                component: resolve => (require(["@/components/login/registerComplete"], resolve))
            }, {
                path: '/forgetPassword',
                name:'login',
                component: resolve => (require(["@/components/login/forgetPassword"], resolve))
            }]
        },
        {
            path: '/',
            component: resolve => (require(["@/components/home/index"], resolve))
        },
        {
            path: '/book',
            component: resolve => (require(["@/components/book/book"], resolve)),
            children:[{
                path: '/book/bookList',
                component: resolve => (require(["@/components/book/bookList"], resolve))
            },{
                path: '/book/bookDetail',
                component: resolve => (require(["@/components/book/bookDetail"], resolve))
            },{
                path: '/book/audioPlay',
                component: resolve => (require(["@/components/book/audioPlay"], resolve))
            },{
                path: '/book/videoPlay',
                component: resolve => (require(["@/components/book/videoPlay"], resolve))
            }]
        },
        {
            path: '/center',
            component: resolve => (require(["@/components/personalCenter/layout"], resolve)),
            children: [{
                path: '/center/changeUserData',
                component: resolve => (require(["@/components/personalCenter/changeUserData"], resolve))
            }, {
                path: '/center/babyChange',
                component: resolve => (require(["@/components/personalCenter/babyChange"], resolve))
            }, {
                path: '/center/langChange',
                component: resolve => (require(["@/components/personalCenter/langChange"], resolve))
            }, {
                path: '/center/history',
                component: resolve => (require(["@/components/personalCenter/history"], resolve))
            }, {
                path: '/center/me',
                component: resolve => (require(["@/components/personalCenter/me"], resolve))
            }, {
                path: '/center/addUserData',
                component: resolve => (require(["@/components/personalCenter/addUserData"], resolve))
            }]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js